module.exports = __webpack_public_path__ + "img/Selia_80X30.535c59b6.png";